import { render, staticRenderFns } from "./TicketRaised.vue?vue&type=template&id=2cbd9af6&"
import script from "./TicketRaised.vue?vue&type=script&lang=js&"
export * from "./TicketRaised.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports